import React from 'react';
import AppData from './AppData.js';
import styles from './Hub.module.css';
import ErrorMessage from '../../components/ErrorMessage/ErrorMessage';
import { ErrorMappings } from '../../shared/_constants/errorMappings.constants';
import config from '../../services/Auth/AuthConfig';
import Loader from '../../components/Loader/Loader';
/**
 * Main Hub Page of Kiosk App which lists internal and external apps
 * @usage : <HubPage/>
 */
export default class HubPage extends React.PureComponent {
  height;

  /**
   * On initial load fetch the application data information
   */
  async componentDidMount() {
    const { languageCode } = this.props;
    /**
     * here we check if the user has necessary authorisation or not. Need to perform following
     * if checkauth returns true then
     *   1) check if user is first time logging in using an api call if yes then show the info modal
     * if checkauth returns false then
     *    1) redirect user to error screen with permission message
     */
    // window.FS.restart();
    this.props.getAuth();
    if (this.props.isAuthorised) {
      this.props.showLoader(true);
      const token = await this.props.getToken(
        [config.scopes[1]],
        this.props.user
      );
      this.props.fetchApplicationData(languageCode);
      this.props.getUserActivities(token);
      this.setState({ isAuthenticated: true });
      this.height = `${
        document.getElementById('stickyMessageBar') &&
        document.getElementById('stickyMessageBar').clientHeight + 56
      }px`;
    } else {
      this.props.showLoader(false);
    }
  }

  async componentDidUpdate(prevProps) {
    const { isAuthorised, languageCode, appData } = this.props;
    if (isAuthorised !== prevProps.isAuthorised && isAuthorised && !appData) {
      this.props.showLoader(true);
      const token = await this.props.getToken(
        [config.scopes[1]],
        this.props.user
      );
      this.props.fetchApplicationData(languageCode);
      this.props.getUserActivities(token);
    } else if (
      languageCode &&
      languageCode !== prevProps.languageCode &&
      isAuthorised
    ) {
      this.props.fetchApplicationData(languageCode);
      this.height = `${
        document.getElementById('stickyMessageBar') &&
        document.getElementById('stickyMessageBar').clientHeight + 56
      }px`;
    }
  }

  /**
   * On click of card open the app in new tab
   * @param redirectTo
   */
  onCardClick = (redirectTo) => {
    const openedTab = window.open(redirectTo, '_blank');
    this.props.storeRedirectionUrls(openedTab);
  };

  render() {
    const { appData, t, appDataFailure, isLoader } = this.props;
    return (
      <div style={{ paddingTop: this.height }} className={styles.applications}>
        {appData &&
          appData.length > 0 &&
          appData.map((data, index) => {
            return (
              <div
                key={index}
                data-testid="internalAppData"
                className={styles.appDetails}
              >
                {appData && (
                  <AppData
                    data={data.Apps}
                    title={data.SectionTitle}
                    subTitle={data.SectionDescritpion}
                    className={
                      data.background === 'white'
                        ? styles.internalAppDataWhite
                        : styles.internalAppData
                    }
                    onClick={this.onCardClick}
                  />
                )}
                {appDataFailure && <div>{t('HubPageFailureMessage')}</div>}
              </div>
            );
          })}
        {this.props.isAuthorised === false && (
          <ErrorMessage code={ErrorMappings[8].code} />
        )}
        {isLoader && <Loader />}
      </div>
    );
  }
}
